<template>
  <div class="warehouse-component">
    <el-table
      :data="tableData"
      style="width: 100%"
      stripe
      border
      size="mini"
      height="calc(100vh - 420px)"
      v-loading="loading"
      :default-sort="{prop: 'date', order: 'descending'}"
    >
      <el-table-column type="index" label="#" width="50" align="center" fixed></el-table-column>
      <el-table-column prop="state" label="状态" width="80" align="center" fixed>
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.state)" size="small">{{ getStatusText(scope.row.state) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="docNum" label="出库单号" min-width="200" sortable>
        <template slot-scope="scope">
          <el-link type="primary" :underline="false" @click="handleView(scope.row)" class="doc-num-link">{{ scope.row.docNum }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="retnTypeName" label="出库类型" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="getTypeTagType(scope.row.retnTypeName)" size="small">{{ scope.row.retnTypeName || '--' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="supplierName" label="供应商" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.supplierName || '--' }}</template>
      </el-table-column>
      <el-table-column prop="costAmt" label="成本金额" width="120" align="right">
        <template slot-scope="scope">
          <span class="amount">¥{{ formatAmount(scope.row.costAmt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createName" label="创建人" width="100" align="center">
        <template slot-scope="scope">{{ scope.row.createName || '--' }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="150" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
      </el-table-column>
      <el-table-column prop="passingOrdersName" label="过单人" width="100" align="center">
        <template slot-scope="scope">{{ scope.row.passingOrdersName || '--' }}</template>
      </el-table-column>
      <el-table-column prop="passingOrdersTime" label="过单时间" width="150" align="center">
        <template slot-scope="scope">{{ formatTime(scope.row.passingOrdersTime) }}</template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.remarks || '--' }}</template>
      </el-table-column>

      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="handleView(scope.row)">详情</el-button>

          <template v-if="scope.row.state === 0">
            <!-- 草稿：修改 / 提交（根据审核流程开关显示）/ 删除 -->
            <el-button type="text" size="mini" @click="handleEdit(scope.row)">修改</el-button>
            <el-button
              v-if="inventoryAuditFlowEnabled"
              type="text"
              size="mini"
              @click="handleSubmit(scope.row)"
            >提交</el-button>
            <el-button type="text" size="mini" style="color: #F56C6C;" @click="handleDelete(scope.row)">删除</el-button>
          </template>

          <template v-else-if="scope.row.state === 2">
            <el-button type="text" size="mini" @click="handleRollback(scope.row)">回退</el-button>
            <el-button type="text" size="mini" @click="handleExamine(scope.row)">审核</el-button>
          </template>

          <template v-else-if="scope.row.state === 4">
            <el-button type="text" size="mini" @click="handleConfirm(scope.row)">过单/出库</el-button>
          </template>

          <template v-else-if="scope.row.state === 5">
            <el-button type="text" size="mini" style="color: #F56C6C;" @click="handleCancel(scope.row)">作废/冲销</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[50, 100, 150, 300]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      ></el-pagination>
    </div>

    <addyk-modal
      v-if="showModal"
      :visible="showModal"
      :mode="currentMode"
      :row-data="currentRowData"
      :putin-type-list="putinTypeList"
      @close="handleCloseDialog"
      @success="handleDialogSuccess"
      @warehouse-switch="handleWarehouseSwitch"
    />

    <el-dialog title="导出进度" :visible.sync="exporting" width="30%" :close-on-click-modal="false" :show-close="false" class="export-progress-dialog">
      <div style="text-align: center;">
        <el-progress type="circle" :percentage="exportProgress" :status="exportProgress === 100 ? 'success' : ''"></el-progress>
        <p style="margin-top: 20px; color: #606266;">
          {{ exportProgress === 100 ? '导出完成' : '正在生成导出文件，请稍候...' }}
        </p>
        <div v-if="exportProgress === 100" style="margin-top: 20px;">
          <el-button type="primary" size="mini" @click="exporting = false">关闭</el-button>
          <el-button type="text" size="mini" @click="handleOpenDownloadFolder" v-if="isElectron">打开下载文件夹</el-button>
        </div>
      </div>
    </el-dialog>

    <div class="excel">
      <el-dialog title="Excel批量导入" :visible.sync="excelDialogVisible" width="80%" top="10vh" :modal="false" custom-class="excel-import-dialog">
        <div class="excel-import-container">
          <div class="left-panel">
            <div class="upload-header">
              <el-upload class="upload-demo" drag action="" :auto-upload="false"
                :file-list="excelFileList" :before-upload="beforeExcelUpload"
                :on-change="handleExcelChange" accept=".xlsx, .xls" :multiple="false">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将Excel文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">
                  支持.xls、.xlsx格式，文件大小不超过10MB<br>建议使用系统提供的模板文件
                </div>
              </el-upload>
            </div>
            <div class="file-info">
              <div class="file-type-select">
                <el-form label-width="80px" size="mini">
                  <el-form-item label="文件类型">
                    <el-select v-model="fileType">
                      <el-option label="Excel" value="excel"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="文件路径">
                    <el-input v-model="filePath" placeholder="上传后自动显示文件路径" readonly>
                      <el-button slot="append" icon="el-icon-refresh" @click="reSelectFile" :disabled="!excelFileList.length">重新选择</el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="file-table">
                <el-table :data="fileList" border height="188">
                  <el-table-column style="font-size: 12px;" prop="name" label="文件名称" width="180"></el-table-column>
                  <el-table-column style="font-size: 12px;" prop="path" label="文件路径" show-overflow-tooltip></el-table-column>
                  <el-table-column style="font-size: 12px;" prop="status" label="状态" width="100">
                    <template slot-scope="{row}">
                      <el-tag :type="row.status === '导入成功' ? 'success' : 'danger'" size="mini">{{row.status}}</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="{row}">
                      <el-button type="danger" icon="el-icon-del" size="mini" circle @click="removeFile(row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="action-footer">
              <el-button type="primary" size="medium" @click="submitExcel" :loading="loading" :disabled="isSubmitDisabled || !excelTableData.length">立即执行</el-button>
            </div>
          </div>
          <div class="right-panel">
            <div class="preview-header">
              <h4>数据预览 (共 {{ excelTableData.length }} 条记录)</h4>
            </div>
            <div class="preview-table">
              <el-table :data="excelTableData" border height="300" v-loading="loading">
                <el-table-column v-for="col in excelColumns" :key="col.prop" :prop="col.prop" :label="col.label" :width="col.width" show-overflow-tooltip></el-table-column>
              </el-table>
            </div>
            <div class="error-info-section" v-if="errorData.length > 0">
              <div class="error-header">
                <h4 style="color: #F56C6C;">
                  <i class="el-icon-warning"></i> 导入错误信息 (共 {{ errorData.length }} 条错误)
                </h4>
                <el-button type="danger" size="mini" icon="el-icon-download" @click="downloadErrorExcel" :loading="downloadingError">下载错误信息</el-button>
              </div>
              <div class="error-table">
                <el-table :data="errorData" border height="300" style="width: 100%" size="mini">
                  <el-table-column label="行号" width="80" align="center" fixed="left">
                    <template slot-scope="{ row, $index }">
                      <span style="font-weight: bold;">第{{ getDisplayRowNumber(row, $index) }}行</span>
                    </template>
                  </el-table-column>
                  <el-table-column v-for="col in excelColumns" :key="col.prop" :prop="col.prop" :label="col.label" :width="col.width" show-overflow-tooltip align="center">
                    <template slot-scope="{ row }">
                      <span>{{ row[col.prop] || '--' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="errorInfo" label="错误原因" width="200" align="center" fixed="right">
                    <template slot-scope="{ row }">
                      <span style="color: #F56C6C; font-weight: bold;">{{ row.errorInfo || '未知错误' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="80" align="center" fixed="right">
                    <template slot-scope="{ row }">
                      <el-button type="text" size="mini" @click="copyErrorInfo(row)">复制</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { toDrugExamine, selectDropDownList, getPutin, editPurchase } from "@/api/PSI.js";
import { shopReturnList, getRetnDetail, docOutDel, selectOut, editdocOut } from "@/api/PSI/shopReturn.js";
import { importExcel } from "@/api/systemCatalogue/Western.js";
import {
  stockPage,
  selectInformation,
  stockAdd,
  stockInfo,
  detailStock,
  infoIsStocked,
  getValueStock,
  stockEditDetail,
  stockInfoing,
  toStockExamine,
  deleteStock,
} from "@/api/PSI.js";

import { 
  msfxCodeDetail, 
  msfxGetEntInfoList, 
  msfListUpoutDetail, 
  msfxUploadInoutBill, 
  msfxUploadRetail,
  getSomeWare,
  getCJSomeWare
} from "@/api/systemCatalogue/Western.js";

import { getSystemList } from "@/api/systemParameter/systemParameter"
import { exportAllWmDrugDgs } from "@/api/PSI.js";
import AddykModal from './addModel.vue';

export default {
  name: 'YK',
  components: {
    AddykModal
  },
  props: {
    filterData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 50,
        totalSize: 0
      },
      putinTypeList: [],
      showModal: false,
      currentMode: 'add',
      currentRowData: null,
      systemParameterList: [],
      msfxEntId: '',
      // 库存审核流程开关：true 显示草稿状态的提交按钮，false 隐藏
      // 默认 true，保持原有流程；找到参数后以服务端配置为准
      inventoryAuditFlowEnabled: true,
      excelDialogVisible: false,
      excelFileList: [],
      excelTableData: [],
      excelColumns: [],
      uploadUrl: 'http://fsapi.nfcis.cn/outpatitent/excel/西药库入库导入模板.xlsx',
      uploadHeaders: {
        'Authorization': localStorage.getItem('token')
      },
      filePath: '',
      fileList: '',
      fileType: 'excel',
      isElectron: false,
      errorData: [],
      downloadingError: false,
      exporting: false,
      exportProgress: 0,
      exportTimer: null,
      exportLoading: false,
      isSubmitDisabled: true,
    };
  },
  created() {
    this.loadPutinTypes();
    this.loadSystemParameters();
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    async loadPutinTypes() {
      try {
        const response = await getPutin();
        if (response && response.data) {
          this.putinTypeList = response.data;
          this.$emit('putin-types-loaded', this.putinTypeList);
        }
      } catch (error) {
        console.error('获取入库类型失败:', error);
        this.$message.error('获取入库类型失败');
      }
    },

    /**
     * 加载系统参数
     * - 同步读取「库存审核流程开关」控制草稿状态是否显示提交按钮
     * - 同时提取「码上放心entid」用于过单追溯码上传
     */
    async loadSystemParameters() {
      try {
        const response = await getSystemList();
        if (response && response.code === 200 && response.data) {
          this.systemParameterList = response.data;

          // 提取码上放心 entId（过单/冲销追溯码上传使用）
          this.findMsfxEntId();

          // 查找「库存审核流程开关」参数：value=1 启用审核流程，value=0 未启用
          const auditFlowParam = this.systemParameterList.find(
            p => p.name && p.name.trim() === '库存审核流程开关'
          );
          if (auditFlowParam && auditFlowParam.value !== undefined && auditFlowParam.value !== null) {
            this.inventoryAuditFlowEnabled = String(auditFlowParam.value).trim() === '1';
          } else {
            // 未配置该参数时保持原有流程（显示提交按钮）
            this.inventoryAuditFlowEnabled = true;
          }
          console.log('库存审核流程开关:', this.inventoryAuditFlowEnabled);
        } else {
          console.warn('获取系统参数失败，保持默认值');
        }
      } catch (error) {
        console.error('获取系统参数异常:', error);
        // 异常情况保持默认 true，不影响主流程
      }
    },

    async loadTableData() {
      this.loading = true;
      try {
        const params = this.buildRequestParams();
        const response = await shopReturnList(params);
        if (response && response.code === 200) {
          this.tableData = response.data.content || [];
          this.pagination.totalSize = response.data.totalSize || response.data.totalElements || 0;
        } else {
          this.tableData = [];
          this.pagination.totalSize = 0;
        }
      } catch (error) {
        console.error('获取西药库数据失败:', error);
        this.$message.error('获取数据失败');
        this.tableData = [];
        this.pagination.totalSize = 0;
      } finally {
        this.loading = false;
      }
    },

    async getSystemParameters() {
      try {
        const response = await getSystemList();
        if (response && response.code === 200 && response.data) {
          this.systemParameterList = response.data;
          this.findMsfxEntId();
        } else {
          console.warn('获取系统参数失败');
        }
      } catch (error) {
        console.error('获取系统参数异常:', error);
      }
    },

    findMsfxEntId() {
      if (!this.systemParameterList || this.systemParameterList.length === 0) {
        this.msfxEntId = '';
        return;
      }
      const param = this.systemParameterList.find(p => p.name && p.name.trim() === '码上放心entid');
      if (param && param.value) {
        this.msfxEntId = param.value.trim();
        console.log('找到码上放心entid:', this.msfxEntId);
      } else {
        this.msfxEntId = '';
        console.warn('未找到码上放心entid参数');
      }
    },

    extractTraceCodesFromDetail(detail) {
      const traceCodes = [];
      const list = detail.list || [];
      list.forEach(item => {
        if (item.isBar === 1) {
          let codes = [];
          if (item.tracCodeJson) {
            try {
              const parsed = JSON.parse(item.tracCodeJson);
              if (Array.isArray(parsed)) {
                codes = parsed.map(c => c.barcode).filter(Boolean);
              }
            } catch (e) {
              console.error('解析 tracCodeJson 失败:', e);
            }
          } else if (item.traceCodes && Array.isArray(item.traceCodes)) {
            codes = item.traceCodes.map(c => c.traceCode).filter(Boolean);
          }
          if (codes.length) {
            traceCodes.push(...codes);
          }
        }
      });
      return traceCodes;
    },

    convertPutinTypeNameToId(typeName) {
      if (!typeName || !this.putinTypeList.length) return null;
      const matched = this.putinTypeList.find(item => item.retnTypeName === typeName);
      if (!matched) {
        console.warn(`未找到入库类型名称 "${typeName}" 对应的 ID，请检查 putinTypeList 数据`);
        return null;
      }
      return matched.id;
    },

    buildRequestParams() {
      const params = {
        ...this.filterData,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize
      };
      if (this.filterData.startDate) params.startDate = this.filterData.startDate;
      if (this.filterData.endDate) params.endDate = this.filterData.endDate;
      if (params.retnTypeName) {
        const typeId = this.convertPutinTypeNameToId(params.retnTypeName);
        if (typeId !== null) {
          params.putinTypeId = typeId;
        }
        delete params.retnTypeName;
      }
      return params;
    },

    formatAmount(amount) {
      if (!amount && amount !== 0) return '0.00';
      return Number(amount).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    formatTime(time) {
      if (!time) return '--';
      if (typeof time === 'number') {
        return new Date(time).toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      return time;
    },

    getStatusText(state) {
      const statusMap = {
        0: '草稿',
        1: '提交回退',
        2: '已提交',
        3: '审核回退',
        4: '已审核',
        5: '已过单',
        6: '已冲销'
      };
      return statusMap[state] || '未知';
    },

    getTypeTagType(retnTypeName) {
      switch(retnTypeName) {
        case '采购': return 'warning';
        case '其他': return 'info';
        case '调拨': return 'primary';
        case '盘点': return 'success';
        default: return 'warning';
      }
    },

    getStatusTagType(state) {
      switch(state) {
        case 0: return 'info';
        case 1: return 'info';
        case 2: return 'warning';
        case 3: return 'warning';
        case 4: return 'primary';
        case 5: return 'success';
        case 6: return 'danger';
        default: return 'info';
      }
    },

    handleCreateInbound() {
      console.log('创建入库单按钮被点击');
      this.currentMode = 'add';
      this.currentRowData = null;
      this.showModal = true;
    },

    handleBatchInbound() {
      this.handleExcelImport();
    },

    handleExcelImport() {
      this.excelDialogVisible = true;
      this.resetImportData();
    },

    beforeExcelUpload(file) {
      const isExcel = file.type.includes('excel') ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls');
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
        return false;
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB!');
        return false;
      }
      return true;
    },

    handleExcelChange(file, fileList) {
      if (fileList.length > 1) {
        this.excelFileList = [fileList[fileList.length - 1]];
        return;
      }
      this.excelFileList = fileList;
      this.filePath = file.name;
      this.excelRawFile = file.raw;
      this.errorData = [];
      this.errorCount = 0;
      this.isSubmitDisabled = false;
      this.fileList = [{
        name: file.name,
        path: file.name,
        status: '待处理'
      }];
      this.readExcel(file.raw);
    },

    reSelectFile() {
      this.resetImportData();
    },

    removeFile(row) {
      this.excelFileList = [];
      this.excelTableData = [];
      this.excelColumns = [];
      this.fileList = [];
      this.filePath = '';
      this.errorData = [];
      this.errorCount = 0;
      this.excelRawFile = null;
      this.$message.info('文件已删除，请重新上传新文件');
    },

    readExcel(file) {
      this.loading = true;
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);
          if (!jsonData || jsonData.length === 0) {
            this.$message.warning('Excel文件没有数据');
            return;
          }
          this.excelColumns = Object.keys(jsonData[0]).map(key => ({
            prop: key,
            label: key,
            width: 150
          }));
          this.excelTableData = jsonData;
          this.fileList[0].status = '导入成功';
          this.$message.success('Excel解析成功');
        } catch (error) {
          this.fileList[0].status = '失败';
          this.$message.error('Excel文件解析失败: ' + error.message);
        } finally {
          this.loading = false;
        }
      };
      reader.onerror = (error) => {
        this.fileList[0].status = '失败';
        this.$message.error('文件读取失败');
        this.loading = false;
      };
      reader.readAsArrayBuffer(file);
    },

    async submitExcel() {
      if (!this.excelRawFile) {
        this.$message.warning('请先上传Excel文件');
        return;
      }
      this.loading = true;
      this.isSubmitDisabled = true;
      try {
        const formData = new FormData();
        formData.append('file', this.excelRawFile);
        formData.append('type', 'western');
        formData.append('clinicId', this.$store.getters.clinicId || '');
        const response = await importExcel(formData);
        if (response.code === 200) {
          if (response.data && Object.keys(response.data).length > 0) {
            this.handleImportErrors(response.data);
            const totalCount = this.excelTableData.length;
            const errorCount = Object.keys(response.data).length;
            const successCount = totalCount - errorCount;
            this.$message.warning(`导入完成！成功 ${successCount} 条，失败 ${errorCount} 条`);
            this.loadTableData();
          } else {
            this.handleImportSuccess();
          }
        } else {
          this.$message.error(response.message || '导入失败');
        }
      } catch (error) {
        console.error('导入失败:', error);
        this.$message.error('导入失败: ' + (error.message || '网络错误'));
      } finally {
        this.loading = false;
      }
    },

    handleImportSuccess() {
      this.$message.success('Excel导入成功！');
      this.excelDialogVisible = false;
      this.resetImportData();
      this.loadTableData();
    },

    resetImportData() {
      this.excelFileList = [];
      this.excelTableData = [];
      this.excelColumns = [];
      this.fileList = [];
      this.filePath = '';
      this.errorData = [];
      this.errorCount = 0;
      this.excelRawFile = null;
      this.isSubmitDisabled = true;
      this.currentPage = 1;
    },

    extractErrorMessages(errorData) {
      if (!errorData) return '未知错误';
      if (typeof errorData === 'string') return errorData;
      if (Array.isArray(errorData)) {
        return errorData.map(item => {
          if (typeof item === 'string') return item;
          if (item.message) return item.message;
          if (item.msg) return item.msg;
          return JSON.stringify(item);
        }).join('; ');
      }
      if (typeof errorData === 'object') {
        if (errorData.message) return errorData.message;
        if (errorData.msg) return errorData.msg;
        const possibleErrorFields = ['error', 'errMsg', 'errorMessage', 'detail'];
        for (const field of possibleErrorFields) {
          if (errorData[field]) return errorData[field];
        }
        return JSON.stringify(errorData);
      }
      return '未知错误类型';
    },

    handleImportErrors(errorData) {
      this.errorData = [];
      this.errorCount = 0;
      try {
        if (typeof errorData === 'object' && errorData !== null) {
          Object.entries(errorData).forEach(([rowNumber, errorInfo]) => {
            const rowIndex = parseInt(rowNumber);
            const originalRow = this.excelTableData[rowIndex] || {};
            const errorRow = {
              id: this.errorData.length + 1,
              rowNumber: rowIndex,
              displayRowNumber: rowIndex + 1,
              errorInfo: errorInfo.msg || this.formatErrorInfo(errorInfo),
              _rawError: errorInfo
            };
            this.excelColumns.forEach(col => {
              errorRow[col.prop] = originalRow[col.prop] || '--';
            });
            this.errorData.push(errorRow);
          });
          this.errorCount = this.errorData.length;
        }
      } catch (error) {
        this.errorData = [{
          id: 1,
          rowNumber: 0,
          displayRowNumber: 1,
          errorInfo: '处理错误信息时发生异常: ' + error.message,
          _rawError: error
        }];
        this.excelColumns.forEach(col => {
          this.errorData[0][col.prop] = '--';
        });
        this.errorCount = 1;
      }
      this.$forceUpdate();
    },

    formatErrorInfo(errorInfo) {
      if (typeof errorInfo === 'string') return errorInfo;
      else if (typeof errorInfo === 'object') {
        const errorMessage = errorInfo.message || errorInfo.msg || errorInfo.error ||
          errorInfo.reason || errorInfo.desc || errorInfo.description;
        if (errorMessage) return errorMessage;
        if (Array.isArray(errorInfo)) {
          return errorInfo.map(err => this.formatErrorInfo(err)).join('; ');
        }
        try { return JSON.stringify(errorInfo); } catch (e) { return '未知错误格式'; }
      }
      return '未知错误';
    },

    async downloadErrorExcel() {
      if (this.errorData.length === 0) {
        this.$message.warning('没有错误信息可下载');
        return;
      }
      this.downloadingError = true;
      try {
        const workbook = XLSX.utils.book_new();
        const errorDataForExport = this.errorData.map((errorRow, index) => {
          const exportRow = {
            '行号': errorRow.displayRowNumber || (index + 1)
          };
          this.excelColumns.forEach(col => {
            exportRow[col.label] = errorRow[col.prop] || '--';
          });
          exportRow['错误原因'] = errorRow.errorInfo || '未知错误';
          return exportRow;
        });
        const worksheet = XLSX.utils.json_to_sheet(errorDataForExport);
        const colWidths = [{ wch: 8 }];
        this.excelColumns.forEach(col => {
          colWidths.push({ wch: col.width ? col.width / 10 : 15 });
        });
        colWidths.push({ wch: 40 });
        worksheet['!cols'] = colWidths;
        XLSX.utils.book_append_sheet(workbook, worksheet, '导入错误信息');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        this.watermarkText = localStorage.getItem('watermarkText') || '西药库';
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const fileName = `${this.watermarkText}入库导入错误信息_${timestamp}.xlsx`;
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 100);
        this.$message.success(`错误信息Excel文件已下载，共 ${this.errorData.length} 条错误记录`);
      } catch (error) {
        console.error('下载错误信息失败:', error);
        this.$message.error('下载错误信息失败: ' + error.message);
      } finally {
        this.downloadingError = false;
      }
    },

    copyErrorInfo(row) {
      let errorText = `行号: ${row.rowNumber || '未知'}\n`;
      this.excelColumns.forEach(col => {
        errorText += `${col.label}: ${row[col.prop] || '--'}\n`;
      });
      errorText += `错误原因: ${row.errorInfo || '未知错误'}`;
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(errorText).then(() => {
          this.$message.success('错误信息已复制到剪贴板');
        }).catch(err => {
          this.fallbackCopyText(errorText);
        });
      } else {
        this.fallbackCopyText(errorText);
      }
    },

    async handleExport() {
      this.$confirm('确定要导出采购入库数据吗？', '导出确认', {
        confirmButtonText: '确定导出',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.handleExportData();
      }).catch(() => {
        this.$message.info('已取消导出');
      });
    },

    async handleExportData() {
      this.exporting = true;
      this.exportProgress = 0;
      try {
        this.startExportProgress();
        const response = await exportAllWmDrugDgs();
        if (response) {
          await this.processExportData(response);
          this.$message.success('导出成功，文件正在下载中...');
        } else {
          this.$message.error('导出数据为空');
        }
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error('导出失败: ' + (error.message || '未知错误'));
        try {
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (typeof errorData === 'string' && errorData.includes('{')) {
              const errorInfo = JSON.parse(errorData);
              this.$message.error(errorInfo.message || errorInfo.msg || '导出接口返回错误');
            }
          }
        } catch (parseError) {}
      } finally {
        this.finishExport();
      }
    },

    startExportProgress() {
      this.exportProgress = 0;
      this.exportTimer = setInterval(() => {
        if (this.exportProgress < 90) {
          this.exportProgress += 10;
        }
      }, 300);
    },

    finishExport() {
      this.exportProgress = 100;
      setTimeout(() => {
        if (this.exportTimer) {
          clearInterval(this.exportTimer);
          this.exportTimer = null;
        }
        this.exporting = false;
        this.exportProgress = 0;
      }, 500);
    },

    async processExportData(blobData) {
      try {
        if (!(blobData instanceof Blob)) {
          console.error('返回的数据不是Blob对象:', typeof blobData);
          if (typeof blobData === 'string') {
            try {
              const errorInfo = JSON.parse(blobData);
              this.$message.error(errorInfo.message || errorInfo.msg || '导出接口返回错误信息');
            } catch (e) {
              this.$message.error('导出数据格式错误: ' + blobData.substring(0, 100));
            }
          } else {
            this.$message.error('导出数据格式不正确，请联系管理员');
          }
          return false;
        }
        if (blobData.size < 100) {
          const text = await this.blobToText(blobData);
          try {
            const errorInfo = JSON.parse(text);
            this.$message.error(errorInfo.message || errorInfo.msg || '导出数据为空或格式错误');
          } catch (e) {
            console.log('Blob内容:', text);
            this.$message.error('导出文件可能已损坏，请联系管理员');
          }
          return false;
        }
        const isValidExcel = blobData.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          blobData.type === 'application/vnd.ms-excel' ||
          blobData.type === 'application/octet-stream';
        if (!isValidExcel) {
          const text = await this.blobToText(blobData);
          try {
            const errorInfo = JSON.parse(text);
            this.$message.error(errorInfo.message || errorInfo.msg || '导出失败');
          } catch (e) {
            this.$message.error('服务器返回非Excel文件: ' + text.substring(0, 200));
          }
          return false;
        }
        const url = window.URL.createObjectURL(blobData);
        const link = document.createElement('a');
        const warehouseName = '西药库';
        const timestamp = new Date();
        const dateStr = timestamp.toLocaleDateString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).replace(/\//g, '');
        const timeStr = timestamp.toLocaleTimeString('zh-CN', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).replace(/:/g, '');
        const fileName = `${warehouseName}入库导入_${dateStr}_${timeStr}.xlsx`;
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.onclick = () => {
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
        };
        link.click();
        console.log('文件下载信息:', {
          文件大小: blobData.size + ' bytes',
          文件类型: blobData.type,
          文件名: fileName
        });
        return true;
      } catch (error) {
        console.error('处理导出数据失败:', error);
        if (error.response && error.response.data) {
          try {
            const errorText = await this.blobToText(error.response.data);
            const errorInfo = JSON.parse(errorText);
            this.$message.error(errorInfo.message || errorInfo.msg || '导出处理失败');
          } catch (parseError) {
            this.$message.error('导出失败: ' + error.message);
          }
        } else {
          this.$message.error('导出失败: ' + (error.message || '未知错误'));
        }
        return false;
      }
    },

    blobToText(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsText(blob);
      });
    },

    getDisplayRowNumber(row, index) {
      if (row.rowNumber !== undefined && row.rowNumber !== null) {
        return parseInt(row.rowNumber) + 1;
      }
      return index + 1;
    },

    fallbackCopyText(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.top = 0;
      textArea.style.left = 0;
      textArea.style.opacity = 0;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) this.$message.success('错误信息已复制到剪贴板');
        else this.$message.error('复制失败，请手动复制');
      } catch (err) {
        this.$message.error('复制失败: ' + err);
      }
      document.body.removeChild(textArea);
    },

    showErrorDetails(errorData) {
      let errorMessage = '导入错误详情:\n\n';
      if (Array.isArray(errorData)) {
        errorData.forEach((error, index) => {
          errorMessage += `${index + 1}. ${this.formatError(error)}\n`;
        });
      } else if (typeof errorData === 'object') {
        Object.entries(errorData).forEach(([key, value], index) => {
          errorMessage += `${index + 1}. ${key}: ${this.formatError(value)}\n`;
        });
      }
      this.$alert(errorMessage, '导入错误详情', {
        confirmButtonText: '确定',
        customClass: 'error-details-dialog',
        dangerouslyUseHTMLString: false
      });
    },

    async handleView(row) {
      try {
        this.loading = true;
        const response = await getRetnDetail({ id: row.id });
        if (response && response.code === 200) {
          this.currentMode = 'view';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取详情失败');
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      } finally {
        this.loading = false;
      }
    },

    async handleQuickTransferDetail(row) {
      try {
        this.loading = true;
        const response = await getRetnDetail({ id: row.id });
        if (response && response.code === 200) {
          this.currentMode = 'fast';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取详情失败');
        }
      } catch (error) {
        console.error('获取详情失败:', error);
        this.$message.error('获取详情失败');
      } finally {
        this.loading = false;
      }
    },

    async handleEdit(row) {
      try {
        this.loading = true;
        const response = await getRetnDetail({ id: row.id });
        if (response && response.code === 200) {
          this.currentMode = 'edit';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    async handleSubmit(row) {
      try {
        this.loading = true;
        const response = await getRetnDetail({ id: row.id });
        if (response && response.code === 200) {
          this.currentMode = 'submit';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm(`确认删除（${row.docNum}）这条入库单吗？`, '提示', {
          type: 'warning'
        });
        const response = await docOutDel({ id: row.id });
        if (response && response.code === 200) {
          this.$message.success(`药库出库单（${row.docNum}）- 草稿 - 已删除`);
          this.loadTableData();
        } else {
          this.$message.error(response.message || '删除失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    },

    async handleRollback(row) {
      try {
        this.loading = true;
        const response = await getRetnDetail({ id: row.id });
        if (response && response.code === 200) {
          this.currentMode = 'rollback';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    async handleExamine(row) {
      try {
        this.loading = true;
        const response = await getRetnDetail({ id: row.id });
        if (response && response.code === 200) {
          this.currentMode = 'review';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    async handleConfirm(row) {
      try {
        this.loading = true;
        const response = await getRetnDetail({ id: row.id });
        if (response && response.code === 200) {
          this.currentMode = 'pass';
          this.currentRowData = {
            ...response.data,
            id: row.id,
            docNum: row.docNum
          };
          this.showModal = true;
        } else {
          this.$message.error(response.message || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    async handleCancel(row) {
      try {
        await this.$confirm(`确认冲销（${row.docNum}）这条入库单吗？`, '提示', {
          type: 'warning'
        });
        const detailRes = await getRetnDetail({ id: row.id });
        if (!detailRes || detailRes.code !== 200) {
          this.$message.error('获取单据详情失败，无法继续');
          return;
        }
        const detail = detailRes.data;
        const traceCodes = [];
        (detail.list || []).forEach(item => {
          if (item.tracCodeJson) {
            try {
              const codes = JSON.parse(item.tracCodeJson);
              if (Array.isArray(codes)) {
                codes.forEach(c => {
                  if (c.barcode) traceCodes.push(c.barcode);
                });
              }
            } catch (e) {
              console.error('解析 tracCodeJson 失败:', e);
            }
          }
        });
        if (traceCodes.length > 0) {
          const loadingInstance = this.$loading({
            text: '正在将已录入的追溯码从码上放心平台入库...',
            fullscreen: true
          });
          try {
            await this.getSystemParameters();
            const fromUserId = this.msfxEntId || '';
            const toUserId = detail.entId || row.entId || '';
            if (!toUserId) {
              console.warn('未获取到供应商 entId，将使用空值');
            }
            const traceCodeStr = traceCodes.join(',');
            const uploadData = {
              billType: 102,
              bizNum: row.docNum,
              fromUserId: fromUserId,
              physicType: 3,
              toUserId: toUserId,
              traceCodes: traceCodeStr
            };
            console.log('冲销追溯码上传参数:', uploadData);
            const uploadRes = await msfxUploadInoutBill(uploadData);
            if (!uploadRes || uploadRes.code !== 200) {
              const errMsg = uploadRes?.message || uploadRes?.msg || '上传追溯码失败';
              await this.$alert(errMsg, '提示', {
                confirmButtonText: '我已知晓',
                type: 'error'
              });
              loadingInstance.close();
              this.loadTableData();
              return;
            }
            loadingInstance.close();
            this.$message.success('追溯码已从码上放心出库！');
          } catch (error) {
            console.error('上传追溯码异常:', error);
            await this.$alert(error.message || '上传追溯码异常', '提示', {
              confirmButtonText: '我已知晓',
              type: 'error'
            });
            loadingInstance.close();
            this.loadTableData();
            return;
          }
        } else {
          console.log('无追溯码需要上传，直接执行冲销');
        }
        const response = await toDrugExamine({
          id: row.id,
          state: 6
        });
        if (response && response.code === 200) {
          this.$message.success('冲销成功');
          this.loadTableData();
        } else {
          this.$message.error(response?.message || '冲销失败');
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('冲销失败:', error);
          this.$message.error('冲销失败');
        }
      }
    },

    handleQuickAllot(row) {
      console.log('快速调拨:', row);
      this.$message.info('快速调拨功能待实现');
    },

    handleOutbound() {
      this.$router.push('/PSI/XyRet');
    },

    handleSearch() {
      this.pagination.pageNum = 1;
      this.loadTableData();
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.pageNum = 1;
      this.loadTableData();
    },

    handleCurrentChange(page) {
      this.pagination.pageNum = page;
      this.loadTableData();
    },

    handleCloseDialog() {
      this.showModal = false;
      this.currentMode = 'add';
      this.currentRowData = null;
    },

    async handleDialogSuccess(data) {
      console.log('入库单创建成功，返回数据:', data);
      this.showModal = false;
      this.currentMode = 'add';
      this.currentRowData = null;
      if (data && data.warehouseId === 2) {
        this.$emit('switch-warehouse', 2);
        this.$message.success('已自动切换到西药房列表');
      }
      this.loadTableData();
    },

    handleWarehouseSwitch(warehouseId) {
      console.log('收到药库切换请求:', warehouseId);
      this.$emit('switch-warehouse', warehouseId);
    },
  },
  watch: {
    filterData: {
      handler(newVal) {
        this.pagination.pageNum = 1;
        this.loadTableData();
      },
      deep: true
    }
  }
};
</script>

<style lang="less" scoped>
.warehouse-component {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .operation-buttons {
    padding: 10px 16px;
    background-color: #fff;
    border-bottom: 1px solid #e8e8e8;
    display: flex;
    gap: 10px;
  }
  
  .pagination-container {
    padding: 12px 16px;
    background-color: #fff;
    border-top: 1px solid #e8e8e8;
    display: flex;
    justify-content: flex-end;
  }
  
  .doc-num-link {
    color: #409EFF;
    font-weight: 500;
    cursor: pointer;
    font-size: 12px;
    &:hover {
      color: #66b1ff;
      text-decoration: underline;
    }
  }
  
  .amount {
    color: #F56C6C;
    font-weight: 600;
  }
  .excel {
  	display: flex;
  	align-items: center;
  	justify-content: center;
	
	/deep/ .el-dialog { border-radius: 10px; }
  	/deep/ .el-dialog__header {
  		padding: 8px;
		border-radius: 10px 10px 0 0;
  		background-color: #00aaff;
  	}
  	/deep/ .el-dialog__title { color: #fff; font-size: 12px; }
  	/deep/ .el-dialog__headerbtn { top: 15px; }
  	/deep/ .el-dialog__headerbtn .el-dialog__close { color: #fff; }
  	/deep/ .el-dialog__headerbtn .el-dialog__close:hover { background-color: brown; }
  	/deep/ .el-table .cell {
  		font-size: 12px;
  		font-weight: 400;
  		color: #0c0c0c;
  		text-align: left;
  	}
  
  	.excel-import-dialog {
  		.el-dialog__body { padding: 10px 20px; }
  	}
  
  	.excel-import-container {
  		display: flex;
  		height: 600px;
  
  		.left-panel {
  			flex: 1;
  			display: flex;
  			flex-direction: column;
  			padding-right: 15px;
  			border-right: 1px solid #ebeef5;
  
  			.upload-header {
  				padding: 10px 0;
  				.upload-demo { text-align: center; }
  			}
  
  			.file-info {
  				flex: 1;
  				display: flex;
  				flex-direction: column;
  
  				.file-type-select {
  					padding: 10px 0;
  					.el-form-item { margin-bottom: 10px; }
  				}
  
  				.file-table { flex: 1; overflow: hidden; }
  			}
  
  			.action-footer {
  				padding: 10px 0;
  				text-align: center;
  				.el-button { width: 100%; }
  			}
  		}
  
  		.right-panel {
  			flex: 2;
  			display: flex;
  			flex-direction: column;
  			padding-left: 15px;
  			overflow: hidden;
  
  			.preview-header {
  				padding: 10px 0;
  				border-bottom: 1px solid #ebeef5;
  				h4 { margin: 0; font-size: 14px; color: #606266; }
  			}
  
  			.preview-table { flex: 1; width: 100%; overflow: hidden; }
  
  			.pagination-footer {
  				padding: 10px 0;
  				text-align: center;
  				border-top: 1px solid #ebeef5;
  			}
  		}
  	}
  
  	.el-upload-dragger { width: 100%; padding: 20px; }
  	.el-upload__tip { font-size: 12px; color: #909399; margin-top: 5px; }
  }
}
</style>